export const insertStr = (str: string, index: number, value: string) => {
  return str.slice(0, index) + value + str.slice(index);
};

// get province and city from address
export const getRegion = (address: string) => {
  const words = address.split(" ");
  if (words.length < 2) return "";
  return words[0] + " " + words[1];
};
